<template>
  <div>
    <Banner />
    <Middle />
    <PageFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import Banner from "@/components/Layout/Home/Banner.vue";
import Middle from "@/components/Layout/Home/Middle.vue";
import PageFooter from "@/components/Layout/Home/PageFooter.vue";

import base64url from "base64url"; // to decode strings
import { mapActions } from "vuex";

export default {
  name: "Home",
  components: {
    Banner,
    Middle,
    PageFooter,
  },
  methods: {
    ...mapActions(["authenticateUser"]),
  },
  created() {
    // Get url query string if it is there
    const arity = this.$route.query.cb;

    // Google oauth is successful
    if (arity && arity !== "none") {
      const buf = arity.split(";");
      const username = base64url.decode(buf[1]) + base64url.decode(buf[4]);
      const password =
        "$2b$10$Lcn2ZN1f5BO.tsnDVXBaN.YMcIIr43WcRHyoTxFvBmHyDrtEDmLgS";

      this.authenticateUser({ username, password, param: "/redirect" });
    }
  },
};
</script>
